var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-msg msg-wrapper"},[_c('div',{staticClass:"msg-owner"},[_vm._v("USER")]),_c('div',{staticClass:"msg-content"},[_vm._v("\n    "+_vm._s(_vm.msg.message.text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }